import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CheckoutPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/cart", { replace: true });
  }, [navigate]);

  return null;
};

export default CheckoutPage;
